
import { createObserver } from '@core/helpers/vue-Intersection-observer'
import logger from '@logger'

export default {
  data() {
    return {
      unobserve: () => {},
    }
  },
  mounted() {
    this.unobserve = createObserver(this.$el, () => {
      this.$emit('viewport-impression')
    })
  },
  beforeDestroy() {
    this.unobserve()
  },
  render(h) {
    const child = (this.$slots.default || []).filter((vnode) => vnode.tag)
    if (child.length === 1) {
      return child[0]
    }
    logger.info('[ViewportTracking] Please provide only 1 child')

    return h('div', 'error')
  },
}
